import {Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {PubSubService} from '@Common/core/services';
import {SubSink} from '@Common/core/utils/subsink';
import {Dossiers, StateEnum} from "app/dar/common/services";
import {DarDossiersService} from "app/dar/common/services/dossiers/dossiers.service";


@Component({
  selector: 'app-edit-stepper',
  templateUrl: './edit-stepper.component.html',
  styleUrls: ['./edit-stepper.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EditStepperComponent implements OnInit, OnDestroy {
  subSink = new SubSink();

  /**
   * Le dossier de demande en recrutement
   */
  dossier: Dossiers = null;
  openComment = false;

  constructor(
    private route: ActivatedRoute,
    private pubSubSvc: PubSubService,
    public dossierSvc: DarDossiersService,
  ) {
  }

  ngOnInit() {
    this._initDossierIfUpdate();
  }

  ngOnDestroy() {
    this.subSink.unsubscribe();
  }

  /**
   * Initialise le dossier dans le cas d'une mise à jour
   * @private
   */
  private _initDossierIfUpdate() {
    const id = this.route.snapshot.params['id'];
    this.openComment = this.route.snapshot.params['openComment'] ?? false;

    if (id && id !== '0') {
      this.pubSubSvc.publish('loading', true);
      this.subSink.sink = this.dossierSvc.get(id)
        .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
        .subscribe((dossier: any) => this.dossier = dossier);
    }
    else {
      this.dossier =  <Dossiers> {
        id: 0,
        reference: null,
        state: StateEnum.demande
      }
    }
  }
}
